<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Flags</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:pr-4">
                        <div class="account-body">
                            <div class="w-full flex mb-3" v-for="flag in keyedFlags">
                                <div class="w-1/2 mr-2">
                                    <input type="text" v-model="flag.key"
                                           class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                                </div>
                                <div class="w-1/2 ml-2">
                                    <input type="text" v-model="flag.value"
                                           class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                                </div>
                            </div>
                            <div class="flex mb-3">
                                <div class="w-1/2 mr-2">
                                    <input type="text" placeholder="New Key" v-model="newFlag.key"
                                           class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                                </div>
                                <div class="w-1/2 ml-2">
                                    <input type="text" placeholder="New Value" v-model="newFlag.value"
                                           @keydown.enter="addFlag"
                                           class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 md:pl-4">

                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>

                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccountFlagsView',
    components: {
        //
    },
    props: {
        flags: {
            type: [Object, Array],
            default() {
                return []
            }
        },
    },
    data() {
        return {
            newFlag: {
                key: null,
                value: null,
            },
            keyedFlags: {
                //
            }
        }
    },
    mounted() {
        this.setMetaTitle('View Flags | JournoLink Control')

        this.keyedFlags = this.transposeFlags(this.flags)
    },
    beforeDestroy() {
        //
    },
    methods: {
        saveForm() {
            if (this.newFlag.key !== null) {
                this.addFlag()
            }

            axios.post(route('accountGroups.flags', this.$route.params.id), {
                flags: this.getFlagsForSave(),
            }).then(response => {
                this.keyedFlags = this.transposeFlags(response.data.accountGroup.flags)
                this.$bus.$emit('alert.success', 'Update Success')
            })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Update Failed')
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        /**
         * Add a new flag to the flag collection
         *
         * @return {void}
         */
        addFlag() {
            this.keyedFlags.push(JSON.parse(JSON.stringify(this.newFlag)))
            this.newFlag.key = this.newFlag.value = null
        },
        /**
         * Transpose key/value flags to object flags
         *
         * @param {Object} input
         * @return {Array}
         */
        transposeFlags(input) {
            let output = []
            for (let key in input) {
                output.push({key: key, value: input[key]})
            }

            return output
        },
        /**
         * Format the current flags for save
         *
         * @return {Object}
         */
        getFlagsForSave() {
            let returnFlags = {}
            for (let flag in this.keyedFlags) {
                returnFlags[this.keyedFlags[flag].key] = this.keyedFlags[flag].value
            }

            return returnFlags
        },
    }
}
</script>

<style lang="less">
.vdp-datepicker {
    display: inline-block;
    border: 1px solid #dddddd;
    padding: 5px;
}

.modal-body {
    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}

p.note {
    margin: 10px 0;
    font-weight: bold;
}
</style>
